// This file was automatically generated from app.shared.dialog.reportItemsAttachments.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.reportItemsAttachments');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.reportItemsAttachments.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="select-attachments-section el8MainFormContainer"><div class="select-attachments-nav el8LeftNavContainer el8OverflowAuto"></div><div class="select-attachments-content el8AttachmentContainerWithLeftNav el8OverflowAuto"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.reportItemsAttachments.feedElem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="clearBPM"><div class="el8TableListContainer attachment-div ', (opt_data.isAttached) ? 'el8BlueHighlightList' : '', '" data-id=', soy.$$escapeHtml(opt_data.attachment.id), ' _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" ><div class="el8TableListItem"><input type="checkbox" class="attachment-checkbox" ', (opt_data.isAttached) ? 'checked' : '', '></input>');
  el8.template.ptdata.letters.attachments.clientGeneratedAttachmentSummary(opt_data.attachment, output);
  output.append('</div></div><div class="el8FeedItemSpacer" style="display:none;"></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.reportItemsAttachments.groupFeedContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="grouped-nav-feed"></div>');
  if (!opt_sb) return output.toString();
};
